import { IPillProps } from '@qapline/ui';

import { TCommissionLiabilityStatus } from '../schemas';

export const COMMISSION_LIABILITY_STATUS_TO_PILL_COLOR: Record<TCommissionLiabilityStatus, IPillProps['color']> = {
    WAITING_FOR_INVOICE: 'gray',
    UNPAID: 'error',
    PAID: 'success',
};
